import * as React from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { cn } from "../../lib/utils";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Button } from "../ui/button";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "../ui/command";

interface ComboboxProps {
  options: {label: string, value: string}[];
  triggerLabel: string;
  optionName: string;
  disabled: boolean | undefined;
  value: string;
  onValueChange: (value: string) => void;
  onSearch?: (search: string) => void;
  disablePortal?: boolean;
}

const Combobox = ({options, triggerLabel, optionName, disabled, value, onValueChange, onSearch, disablePortal = false}: ComboboxProps) => {
  const [open, setOpen] = React.useState(false)
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className="justify-between"
          disabled={disabled}
        >
          {value
            ? options.find((option) => option.value === value)?.label
            : triggerLabel}
          <ChevronsUpDown className="opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0" disablePortal={disablePortal}>
        <Command>
          <CommandInput 
            placeholder={triggerLabel} 
            className="h-9"
            onValueChange={onSearch}
          />
          <CommandList>
            <CommandEmpty>Aucun {optionName} trouvé.</CommandEmpty>
            <CommandGroup>
              {options.map((option) => (
                <CommandItem
                  key={option.value}
                  value={option.label}
                  onSelect={(currentValue) => {
                    const selectedOption = options.find(opt => opt.label === currentValue)
                    onValueChange(selectedOption ? selectedOption.value === value ? "" : selectedOption.value : "")
                    setOpen(false)
                  }}
                >
                  {option.label}
                  <Check
                    className={cn(
                      "ml-auto",
                      value === option.value ? "opacity-100" : "opacity-0"
                    )}
                  />
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  )
}


export { Combobox };
